<h3>Additional Features</h3>
<div class="additional-features">
  <div class="additional-feature" *ngFor="let feature of additionalFeatures">
    <h4>{{ feature.title }}</h4>
    <p>{{ feature.description }}</p>
  </div>
</div>
